import styled from "styled-components";

export const Wrapper = styled.div`
  body{background-color:#F1F2F4 !important}
`;
